import { useEffect, useState } from "react";
import axios from "axios";
import API_URL from "../../config";
import { Loader2, ChevronLeft, ChevronRight, Inbox, Eye } from "lucide-react";
import { useNavigate } from "react-router-dom";

const LeadsList = () => {
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({});

  useEffect(() => {
    const fetchList = async () => {
      try {
        setLoading(true);

        const res = await axios.get(
          `${API_URL}/api/contact/help-center?page=${page}&limit=10`,
        );

        const updated = (res.data.data || []).map((item) => ({
          ...item,
          name: item.name || "No Name",
          status: item.status || "New",
        }));

        setData(updated);

        setPagination({
          total: res.data.count,
          totalPages: res.data.totalPages,
        });
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchList();
  }, [page]);

  const getStatusBadge = (status) => {
    const map = {
      New: "bg-primary",
      contacted: "bg-warning text-dark",
      resolved: "bg-success",
      qualified: "bg-info",
      lost: "bg-danger",
    };
    return `badge ${map[status] || "bg-secondary"} px-2 py-1`;
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100 bg-dark text-white">
        <Loader2 className="spin" size={50} />
      </div>
    );
  }

  return (
    <div className="container py-4" style={{ color: "#e2e8f0" }}>
      <div
        className="card border-0 rounded-4"
        style={{
          background: "#",
          boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
        }}
      >
        <div
          className="card-header d-flex justify-content-between align-items-center border-0"
          style={{ background: "#6600cc" }}
        >
          <div>
            <h5 className="fw-bold mb-0 text-white">Contact Leads</h5>
            <small className="">Manage incoming messages</small>
          </div>

          <span className="badge px-3 py-2">{pagination?.total || 0}</span>
        </div>

        <div className="table-responsive">
          <table className="table mb-0 text-black">
            <thead>
              <tr className="">
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Status</th>
                <th>Date</th>
                <th className="text-end">Actions</th>
              </tr>
            </thead>

            <tbody className="">
              {data.length > 0 ? (
                data.map((item) => (
                  <tr
                    key={item._id}
                    style={{
                      borderBottom: "1px solid #fff",
                      transition: "0.2s",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.background = "#fff")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.background = "transparent")
                    }
                  >
                    <td className="fw-semibold">{item.name}</td>

                    <td className="text-secondary">{item.email}</td>

                    <td>{item.phone_no}</td>

                    <td>
                      <span className={getStatusBadge(item.status)}>
                        {item.status}
                      </span>
                    </td>

                    <td>{new Date(item.createdAt).toLocaleDateString()}</td>

                    <td className="text-end">
                      <button
                        className="d-flex align-items-center gap-2 px-3 py-1"
                        style={{
                          border: "1px solid rgba(59,130,246,0.6)",
                          color: "#60a5fa",
                          background: "transparent",
                          borderRadius: "8px",
                          fontSize: "14px",
                          transition: "all 0.2s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = "#3b82f6";
                          e.currentTarget.style.color = "#fff";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = "transparent";
                          e.currentTarget.style.color = "#60a5fa";
                        }}
                        onClick={() => navigate(`/lead-view/${item._id}`)}
                      >
                        <Eye size={16} />
                        View
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center py-5">
                    <Inbox size={40} />
                    <p>No data found</p>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div
          className="d-flex justify-content-between align-items-center p-3"
          style={{ borderTop: "1px solid #fff" }}
        >
          <button
            className="btn btn-primary"
            disabled={page <= 1}
            onClick={() => setPage((p) => p - 1)}
          >
            <ChevronLeft /> Prev
          </button>

          <span className="text-secondary">
            Page {page} / {pagination.totalPages || 1}
          </span>

          <button
            className="btn btn-primary"
            disabled={page >= (pagination.totalPages || 1)}
            onClick={() => setPage((p) => p + 1)}
          >
            Next <ChevronRight />
          </button>
        </div>
      </div>

      <style>{`
        .spin {
          animation: spin 1s linear infinite;
        }
        @keyframes spin {
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default LeadsList;
